'use strict';

const _ = require('lodash');
const { secrets } = require('../environment');

const environment = process.env.NODE_ENV;
const isProd = environment === 'production';
const isStaging = environment === 'staging';
const CDN_BASE_URL = secrets.cdnBaseUrl;
const WEBPACK_URL = secrets.webpackUrl;

const assets = require(`${__dirname}/../../asset_paths.json`);

class AssetPath {

  static get(path) {
    const assetPath = path.split(/\//g);

    if (path[0] === '/') {
      if (process.env.NODE_ENV === 'development') {
        return `${WEBPACK_URL}${path}`;
      }

      assetPath.shift();
    }

    const fileName = assetPath.pop();
    const assetObj = _.get(assets, `${assetPath.join('.')}`);
    let asset;
    for (const k in assetObj) {
      if (assetObj.hasOwnProperty(k)) {
        const regex = new RegExp(k.replace('.', '\\.').replace(/\*/g, '(.*?)'));
        if (regex.test(fileName)) {
          asset = fileName.replace(regex, assetObj[k]);
          break;
        }
      }
    }

    if (!asset) {
      return isProd || isStaging ? '' : path;
    }

    return asset
      .replace(/%CDN%/, CDN_BASE_URL)
      .replace(/%WEBPACK%/, WEBPACK_URL);
  }
}

module.exports = AssetPath;
